import { render, staticRenderFns } from "./deleteComplaintType.vue?vue&type=template&id=355c14c8"
import script from "./deleteComplaintType.vue?vue&type=script&lang=js"
export * from "./deleteComplaintType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports